import { render, staticRenderFns } from "./NDCTag.vue?vue&type=template&id=4385c58e&scoped=true&"
import script from "./NDCTag.vue?vue&type=script&lang=js&"
export * from "./NDCTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385c58e",
  null
  
)

export default component.exports